import React, { useEffect, useState, useRef, Fragment } from "react";
import { getEventosCalendarioParalimpicos } from "../../../services/getEventosCalendario.js";
import { getPaisesParalimpicos } from "../../../services/getPaisesCalendario.js";
import { getCompetenciasParalimpicos } from "../../../services/getCompetenciasCalendario.js";
import { getFechasParalimpicos } from "../../../services/getFechasCalendario.js";
import { getSystemDay } from "functions/functions.js";
import Loading from "components/loading/loading.js";
import Error from "components/error/error.js";
import SinResultados from "components/calendarios/calendarioGangwon/sinResultados/sinResultados.js";
import FiltrosComponent from "components/calendarios/calendarioGangwon/filtrosCalendario/filtro.js";
import CardEventoCalendarioParalimpicos from "./cardEventoCalendarioParalimpicos/cardEventoCalendarioParalimpicos.js";
import "./calendarioParalimpicos.sass";
import "./../../../css/icomoon.css";
import "./../../../css/cardEventoCalendarioGlobal.sass";


export default function CalendarioParalimpicos({ seccion }) {
    const [showLoading, setShowLoading] = useState(true);
    const [error, setError] = useState(false);

    const [dataEventos, setDataEventos] = useState([]);
    const [dataPaises, setDataPaises] = useState(false);
    const [dataCompetencias, setDataCompetencias] = useState(false);
    const [dataFechas, setDataFechas] = useState(false); //useState("2024-07-24")/

    const [valorFiltroPais, setValorFiltroPais] = useState(false);
    const [valorFiltroCompetencias, setValorFiltroCompetencias] = useState(false);
    const [valorFiltroFechas, setValorFiltroFechas] = useState(false);

    const [mostrarTodos, setMostrarTodos] = useState(false);
    const [ocultarTodos, setOcultarTodos] = useState(false);

    const [desactivar, setDesactivar] = useState(false);
    const [arrayMostrar, setArrayMostrar] = useState([]);

    // asigna color del fondo al contenedor general
    useEffect(() => {
        let colorFondo = "#fff";
        document.getElementById("body").style.backgroundColor = colorFondo;
    }, []);

    // verificacion para obtener la fecha que debe estar por defecto en el select de fecha
    useEffect(() => {
        // Verificar si hay fechas disponibles
        if (dataFechas !== false) {
            let fechaActual = getSystemDay();
            const firstDate = dataFechas[0]?.value;
            const lastDate = dataFechas[dataFechas.length - 1]?.value;

            // si la fecha actual es diferente a la fecha inicial - ASIGNA DIA 0
            if (fechaActual <= firstDate) {
                setValorFiltroFechas(firstDate);
            }
            // si la fecha actual es MAYOR o IGUAL a la fecha fin - ASIGNA ULTIMO DIA
            else if (fechaActual >= lastDate) {
                setValorFiltroFechas(lastDate);
            }
            // si la fecha actual es IGUAL a alguna de las fechas - ASIGNA LA FECHA QUE COINCIDE
            else if (dataFechas.some((item) => item.value === fechaActual)) {
                // Asigna el valor de fechaActual a setNuevo
                setValorFiltroFechas(fechaActual);
            }
            // si no coincide con ninguna opción, asigna la fecha de inicio por defecto
            else {
                setValorFiltroFechas(firstDate);
            }
        }
    }, [dataFechas]);

    // peticion al servicio para obtener los eventos del calendario
    useEffect(() => {
        // Realizar la petición al servicio para obtener los eventos del calendario
        if (valorFiltroFechas) {
            setShowLoading(true);
            setError(false);

            getEventosCalendarioParalimpicos(valorFiltroFechas, seccion)
                .then((eventos) => {
                    let dia = valorFiltroFechas.replace(/-/g, "");

                    if (eventos && eventos.data && eventos.data.length !== 0 && eventos.statusCode === 200) {
                        let transmissions = eventos.data.sort(function (a, b) {
                            return new Date(a.startDate) - new Date(b.startDate) || new Date(a.endDate) - new Date(b.endDate)
                        })
                        setDataEventos(transmissions);
                    } else if (eventos && eventos.statusCode === 404 && eventos.statusCode !== undefined) {
                        setError(true);
                        setDataEventos([]);
                    }
                })
                .finally(() => {
                    setShowLoading(false);
                    setDesactivar(false);
                });
        }
    }, [seccion, valorFiltroFechas])

    useEffect(() => {
        if (!showLoading) {
            setDesactivar(false);
        }
    }, [showLoading])


    useEffect(() => {
        if (!showLoading) {
            setDesactivar(false);
        }
    }, [showLoading])

    // obtener data para select paises
    useEffect(() => {
        getPaisesParalimpicos()
            .then((data) => {
                setDataPaises(data);
            })
            .catch((error) => {
                console.error("Error al obtener los paises:", error);
            });
    }, []);

    // obtener data para select deportes
    useEffect(() => {
        getCompetenciasParalimpicos()
            .then((data) => {
                setDataCompetencias(data);
            })
            .catch((error) => {
                console.error("Error al obtener los paises:", error);
            });
    }, []);

    useEffect(() => {
        getFechasParalimpicos()
            .then((data) => {
                setDataFechas(data);
            })
            .catch((error) => {
                console.error("Error al obtener los paises:", error);
            });
    }, []);

    // funcionamiento del select filtro pais
    const seleccionarFiltroPais = (seleccion) => {
        let pais = String(seleccion.target.value).trim();

        if (pais.length === 0) {
            setValorFiltroPais(false);
        } else {
            setValorFiltroPais(pais);
        }
    };


    // funcionamiento del select filtro competencias (deportes)
    const seleccionarFiltroCompetencias = (seleccion) => {
        let competencia = String(seleccion.target.value).trim();

        if (competencia.length === 0) {
            setValorFiltroCompetencias(false);
        } else {
            setValorFiltroCompetencias(competencia);
        }
    };

    // funcionamiento del select filtro fecha
    const seleccionarFiltroFecha = (seleccion) => {
        const fecha = seleccion.target.value;

        if (fecha.length === 0) {
            setValorFiltroFechas(false);
        } else {
            setValorFiltroFechas(fecha);
            setDataEventos([]);
        }
    };

    // funcionamiento del boton para aumentar la fecha seleccionada
    const aumentarFecha = () => {
        const indexFechaActual = dataFechas.findIndex(
            (fecha) => fecha.value === valorFiltroFechas
        );

        // Verificar si la fecha actual está en dataFechas
        if (indexFechaActual !== -1 && indexFechaActual < dataFechas.length - 1) {
            // Obtener la siguiente fecha en dataFechas
            const siguienteFecha = dataFechas[indexFechaActual + 1].value;

            setDataEventos([]);
            setShowLoading(true);
            // Asignar la siguiente fecha a valorFiltroFechas
            setValorFiltroFechas(siguienteFecha);

            setMostrarTodos(false);
            setOcultarTodos(false);
        }
    };

    // funcionamiento del boton para disminuir la fecha seleccionada
    const disminuirFecha = () => {
        const indexFechaActual = dataFechas.findIndex(
            (fecha) => fecha.value === valorFiltroFechas
        );

        // Verificar si la fecha actual está en dataFechas y no es la primera fecha
        if (indexFechaActual !== -1 && indexFechaActual > 0) {
            // Obtener la fecha anterior en dataFechas
            const anteriorFecha = dataFechas[indexFechaActual - 1].value;

            setDataEventos([]);
            setShowLoading(true);
            // Asignar la fecha anterior a valorFiltroFechas
            setValorFiltroFechas(anteriorFecha);

            setMostrarTodos(false);
            setOcultarTodos(false);
        }
    };

    // funcion para mostrar todos los eventos
    const handleClickMostrar = () => {
        setMostrarTodos((prevMostrarTodos) => !prevMostrarTodos);
    };


    // funcion para  ocultar todos los eventos
    const handleClickOcultar = () => {
        setOcultarTodos((prevOcultarTodos) => !prevOcultarTodos);
    };

    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const calendarioRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (calendarioRef.current) {
            resizeObserver.observe(calendarioRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [calendarioRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------

    //________________ FUNCIONAMIENTO DE FILTRADO _________________
    // Función de filtro por eventos
    const filtrarEventos = (eventos) => {
        return eventos && eventos.filter((evento) => {
            return (!valorFiltroPais || evento.countries_ids?.some((country) => String(country).includes(valorFiltroPais))) &&
                (!valorFiltroCompetencias || String(evento.sportCode).includes(valorFiltroCompetencias));
        });
    };

    // efecto para aplicar en las tarjetas la opcion de mostrar todos
    useEffect(() => {
        if (mostrarTodos) {
            setOcultarTodos(false);
            const ids = dataEventos.map((item) => item.sessionId);

            // Establecer el arrayMostrar con todos los _id
            setArrayMostrar(ids);
        }
    }, [mostrarTodos, dataEventos]);

    // efecto para aplicar en las tarjetas la opcion de ocultar todos
    useEffect(() => {
        if (ocultarTodos) {
            setArrayMostrar([]);
            setMostrarTodos(false);
        }
    }, [ocultarTodos]);


    const eventosFiltrados = filtrarEventos(dataEventos);
    return (
        <div className="container-calendario" id="calendario-paralimpicos" ref={calendarioRef}>
            <>
                <FiltrosComponent
                    seleccionarFiltroCompetencias={seleccionarFiltroCompetencias}
                    dataCompetencias={dataCompetencias}
                    seleccionarFiltroPais={seleccionarFiltroPais}
                    dataPaises={dataPaises}
                    handleClickMostrar={handleClickMostrar}
                    handleClickOcultar={handleClickOcultar}
                    seleccionarFiltroFecha={seleccionarFiltroFecha}
                    dataFechas={dataFechas}
                    disminuirFecha={disminuirFecha}
                    aumentarFecha={aumentarFecha}
                    valorFiltroFechas={valorFiltroFechas}
                    showLoading={showLoading}
                    desactivar={desactivar}
                    componenteActual="paralimpicos"
                />

                <div className="container-eventos">

                    {showLoading && (<Loading />)}

                    {!showLoading && !error && dataEventos && (dataEventos.length === 0 || filtrarEventos(dataEventos).length === 0) && <SinResultados componenteActual="paralimpicos" />}

                    {!showLoading && !error && dataEventos.length !== 0 && filtrarEventos(dataEventos).length !== 0
                        && (filtrarEventos(dataEventos).map((evento, indice) => (
                            <Fragment key={indice}>
                                <CardEventoCalendarioParalimpicos
                                    mostrarTodos={mostrarTodos}
                                    setMostrarTodos={setMostrarTodos}
                                    id={evento.sessionId}
                                    titulo={evento.name}
                                    items={evento.events && evento.events.sort((a, b) => new Date(a.startDate) - new Date(b.startDate))}
                                    fechaInicio={evento.startDate}
                                    fechaFin={evento.endDate}
                                    dataEventos={dataEventos}
                                    sportCode={evento.sportCode}
                                    arrayMostrar={arrayMostrar}
                                    setArrayMostrar={setArrayMostrar}
                                    fechaAnterior={
                                        indice > 0 && eventosFiltrados[indice - 1]
                                            ? eventosFiltrados[indice - 1].startDate
                                            : null
                                    }
                                    is_live={evento.is_live}
                                    valorFiltroCompetencias={valorFiltroCompetencias}
                                />
                            </Fragment>
                        )
                        ))}

                    {!showLoading && error && (<Error mensaje="Ha ocurrido un error al cargar la información" error="¡Lo sentimos!" componenteActual="paralimpicos" />)}
                </div>
            </>
        </div>
    );
}